import { useEffect } from "react";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from "next/router";
import HomeContainer from "@components/views/Home/HomeContainer";

function RootPage() {
  const router = useRouter();

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_AUTONOMOUS_CUSTOMER !== "true") router.replace("/home");
  }, []);

  if (process.env.NEXT_PUBLIC_AUTONOMOUS_CUSTOMER !== "true") return null;

  return <HomeContainer />;
}

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["closets", "common"])),
    },
  };
}

RootPage.requireAuth = process.env.NEXT_PUBLIC_AUTONOMOUS_CUSTOMER !== "true";

export default RootPage;
